var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (g && (g = 0, op[0] && (_ = 0)), _) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
import React from 'react';
import { useRequest } from '../../../hooks/requestHook';
import { useRoaster } from '../../../hooks/useRoaster';
import { typicaStockItem as api } from '../../../api';
import PageLayout from '../../atoms/PageLayout';
import { useTranslation } from 'react-i18next';
import OrderedItemsTable from '../../Order/OrderedItemsTable';
import { toOrderedItem } from '../../Order/utils';
import { Box, Grid, LinearProgress } from '@mui/material';
import CuppingCommentsDialog from '../../Order/CuppingCommentsDialog';
import FullScreenDialog from '../../molecules/FullScreenDialog';
import SimulatedOrderPriceTable from '../../Order/SimulatedOrderPrice';
import { orderPrice as orderPriceApi } from '../../../api';
import OrderForm from '../../Order/OrderForm';
import StickyShoppingCart from '../../Order/StickyShoppingCart';
import OrderShoppingCart from '../../Order/OrderShoppingCart';
import { formatMoneyAmount } from '../../../utils/format';
import OfferListTitle from './OfferListTitle';
import CountryTitle from './CountryTitle';
import OfferListBasicInformation from '../../organisms/OfferListBasicInformation';
import { camelize } from '../../../utils/camelize';
import { useLabelForEstimatedDeliveryPeriod } from '../../../hooks/useLabel';
import { useLocation } from 'react-router-dom';
import SampleOrderShoppingCart from '../../Order/SampleOrderShoppingCart';
import SampleOrderForm from '../../Order/SampleOrderForm';
var RoasterTypicaSelectionPage = function () {
    var t = useTranslation().t;
    var roaster = useRoaster().roaster;
    var getTypicaStockItems = useRequest(api.getAll);
    var _a = React.useState(false), loading = _a[0], setLoading = _a[1];
    var _b = React.useState([]), orderedItems = _b[0], setOrderedItems = _b[1];
    var _c = React.useState(), cuppingCommentOrderedItem = _c[0], setCuppingCommentOrderedItem = _c[1];
    var _d = React.useState(false), openOrderForm = _d[0], setOpenOrderFrom = _d[1];
    var _e = React.useState(false), openSampleOrderForm = _e[0], setOpenSampleOrderFrom = _e[1];
    var _f = React.useState(''), warehouseUnitPrice = _f[0], setWarehouseUnitPrice = _f[1];
    var _g = React.useState('one_time_after_first_delivery'), paymentTiming = _g[0], setPaymentTiming = _g[1];
    var _h = React.useState(), simulatedOrderPrice = _h[0], setSimulatedOrderPrice = _h[1];
    var simulateOrderPriceApi = useRequest(orderPriceApi.simulation);
    var labelForEstimatedDeliveryPeriod = useLabelForEstimatedDeliveryPeriod();
    var hash = useLocation().hash;
    var _j = React.useState('order'), orderFormType = _j[0], setOrderFormType = _j[1];
    React.useEffect(function () {
        if (!roaster)
            return;
        var canceled = false;
        (function () { return __awaiter(void 0, void 0, void 0, function () {
            var response, _a, unitPrice, currency, id, element;
            return __generator(this, function (_b) {
                switch (_b.label) {
                    case 0:
                        setLoading(true);
                        return [4 /*yield*/, getTypicaStockItems({
                                q: {
                                    purchasable: [null, roaster.id],
                                    imported: [roaster.id],
                                    with_ordered_quantity: true,
                                    remaining: true,
                                },
                                per: 1000,
                                page: 1,
                            })];
                    case 1:
                        response = _b.sent();
                        if (!response || canceled)
                            return [2 /*return*/];
                        if (response.data[0]) {
                            _a = response.data[0].warehouse, unitPrice = _a.unitPrice, currency = _a.currency;
                            setWarehouseUnitPrice(formatMoneyAmount(unitPrice, currency));
                        }
                        setOrderedItems(response.data.map(function (item) {
                            return toOrderedItem('TypicaStockItem', item, roaster);
                        }));
                        setLoading(false);
                        id = hash.slice(1);
                        element = document.getElementById(id);
                        element === null || element === void 0 ? void 0 : element.scrollIntoView({ behavior: 'smooth' });
                        return [2 /*return*/];
                }
            });
        }); })();
        return function () {
            canceled = true;
        };
    }, [roaster, getTypicaStockItems, hash]);
    var requestItems = React.useMemo(function () {
        return orderedItems
            .filter(function (orderedItem) { return orderedItem.orderAmount > 0; })
            .map(function (orderedItem) { return ({
            lotNumber: orderedItem.offer.lotNumber,
            orderedItemId: orderedItem.id,
            quantity: orderedItem.orderAmount,
            roasterTransportToWarehousesStatus: orderedItem.transportToWarehousesStatus,
            remainingQuantity: orderedItem.remainingQuantity,
            minOrder: orderedItem.minOrder,
            bagSize: orderedItem.bagSize,
        }); });
    }, [orderedItems]);
    var handleShowFormTypeChange = React.useMemo(function () {
        if (requestItems.every(function (_a) {
            var roasterTransportToWarehousesStatus = _a.roasterTransportToWarehousesStatus;
            return roasterTransportToWarehousesStatus !== 'warehousing';
        }))
            return;
        return function (formType) { return setOrderFormType(formType); };
    }, [requestItems, setOrderFormType]);
    var sampleRequestItems = React.useMemo(function () {
        return orderedItems.filter(function (orderedItem) { return orderedItem.sampleOrdered; });
    }, [orderedItems]);
    var cartItemExists = React.useMemo(function () { return requestItems.length > 0 || sampleRequestItems.length > 0; }, [requestItems, sampleRequestItems]);
    React.useEffect(function () {
        if (requestItems.length === 0 || !roaster)
            return;
        var canceled = false;
        (function () { return __awaiter(void 0, void 0, void 0, function () {
            var items, response;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        items = requestItems.map(function (_a) {
                            var orderedItemId = _a.orderedItemId, quantity = _a.quantity;
                            return ({
                                typica_stock_item_id: orderedItemId,
                                quantity: quantity,
                            });
                        });
                        return [4 /*yield*/, simulateOrderPriceApi({
                                items: items,
                                bids: [],
                                payment_timing: paymentTiming,
                                roaster_id: roaster.id,
                            })];
                    case 1:
                        response = _a.sent();
                        if (!response) {
                            setSimulatedOrderPrice(undefined);
                            return [2 /*return*/];
                        }
                        if (canceled)
                            return [2 /*return*/];
                        setSimulatedOrderPrice(response);
                        return [2 /*return*/];
                }
            });
        }); })();
        return function () {
            canceled = true;
        };
    }, [simulateOrderPriceApi, requestItems, paymentTiming, roaster]);
    var orderedItemsByCountryAndOfferList = React.useMemo(function () {
        return orderedItems.reduce(function (result, item) {
            var offerList = item.offer.offerList;
            var id = offerList.id, _a = offerList.producer, country = _a.country, countryInformation = _a.countryInformation;
            if (!result[country]) {
                result[country] = { countryInformation: countryInformation, offerListMap: {} };
            }
            if (!result[country].offerListMap[id]) {
                result[country].offerListMap[id] = { offerList: offerList, orderedItems: [] };
            }
            result[country].offerListMap[id].orderedItems.push(item);
            return result;
        }, {});
    }, [orderedItems]);
    var handleOrderedItemChange = React.useCallback(function (item) {
        setOrderedItems(function (oldItems) {
            return oldItems.map(function (oldItem) { return (oldItem.id === item.id ? item : oldItem); });
        });
    }, [setOrderedItems]);
    var offers = React.useMemo(function () { return orderedItems.map(function (item) { return item.offer; }); }, [orderedItems]);
    var isUSRoaster = React.useMemo(function () { var _a; return ((_a = roaster === null || roaster === void 0 ? void 0 : roaster.country) === null || _a === void 0 ? void 0 : _a.code) === 'US'; }, [roaster]);
    var paymentPeriod = React.useMemo(function () {
        return ['oneTimeAfterFirstDelivery', 'afterEachDelivery']
            .map(function (paymentTiming) { return t("params.order.paymentTimings.".concat(paymentTiming)); })
            .join(' or ');
    }, [t]);
    if (loading || !roaster)
        return React.createElement(LinearProgress, null);
    return (React.createElement(PageLayout, { title: t('pages.typicaSelection.title') },
        Object.entries(orderedItemsByCountryAndOfferList).map(function (_a) {
            var country = _a[0], _b = _a[1], countryInformation = _b.countryInformation, offerListMap = _b.offerListMap;
            return (React.createElement("div", { key: country },
                React.createElement(CountryTitle, { code: country, countryInformation: countryInformation }),
                Object.entries(offerListMap).map(function (_a) {
                    var _b, _c;
                    var id = _a[0], _d = _a[1], offerList = _d.offerList, items = _d.orderedItems;
                    var transportStatus = (_c = (_b = offerList.roasterTransportToWarehouse) === null || _b === void 0 ? void 0 : _b.status) !== null && _c !== void 0 ? _c : '';
                    var estimatedDeliveryPeriod = transportStatus === 'warehousing'
                        ? t('pages.typicaSelection.estimatedDeliveryPeriod')
                        : labelForEstimatedDeliveryPeriod(offerList.roasterTransportToWarehouse);
                    return (React.createElement(Box, { key: id, mb: 5, id: id },
                        React.createElement(OfferListTitle, { offerList: offerList }),
                        React.createElement(Box, { marginBottom: 3 },
                            React.createElement(OfferListBasicInformation, { status: t("params.transportToWarehouse.statuses.".concat(camelize(transportStatus))), sampleOrderPeriod: t('pages.typicaSelection.sampleOrderPeriod'), orderPeriod: t('pages.typicaSelection.orderPeriod'), paymentPeriod: paymentPeriod, estimatedDeliveryPeriod: estimatedDeliveryPeriod })),
                        React.createElement(OrderedItemsTable, { role: "roaster", orderedItems: items, totalSampleOrderedCount: sampleRequestItems.length, totalOrderedCount: requestItems.length, onOrderedItemChange: handleOrderedItemChange, onOpenCuppingComment: setCuppingCommentOrderedItem, isUSRoaster: isUSRoaster })));
                })));
        }),
        React.createElement(FullScreenDialog, { keepMounted: true, title: t('pages.typicaSelection.order'), open: openOrderForm, onClose: function () {
                setOrderFormType('order');
                setOpenOrderFrom(false);
            } },
            React.createElement(Grid, { container: true },
                React.createElement(Grid, { item: true, xs: 12, md: 5 }, simulatedOrderPrice && (React.createElement(SimulatedOrderPriceTable, { itemType: "TypicaStockItem", offers: offers, simulatedOrderPrice: simulatedOrderPrice, isUSRoaster: isUSRoaster }))),
                React.createElement(Grid, { item: true, xs: 12, md: 7 },
                    React.createElement(OrderForm, { roaster: roaster, role: "roaster", itemType: "TypicaStockItem", requestItems: requestItems, requestBids: [], showFormType: orderFormType, onShowFormTypeChange: handleShowFormTypeChange, simulatedOrderPrice: simulatedOrderPrice, secondsToStartOrder: -1, warehouseUnitPrice: warehouseUnitPrice, onPaymentTimingChange: setPaymentTiming, isValidOrder: cartItemExists })))),
        React.createElement(FullScreenDialog, { title: t('pages.roasterOrder.sampleOrder'), open: openSampleOrderForm, onClose: function () { return setOpenSampleOrderFrom(false); } },
            React.createElement(SampleOrderForm, { role: "roaster", roaster: roaster, orderedItems: sampleRequestItems })),
        React.createElement(StickyShoppingCart, { visible: cartItemExists },
            sampleRequestItems.length > 0 && (React.createElement(SampleOrderShoppingCart, { sampleOrderedItems: sampleRequestItems, onOpenSampleOrderForm: function () { return setOpenSampleOrderFrom(true); } })),
            requestItems.length > 0 && simulatedOrderPrice && (React.createElement(OrderShoppingCart, { orderedItemType: "TypicaStockItem", orderedItems: orderedItems, simulatedOrderPrice: simulatedOrderPrice, buttonTitle: t('pages.typicaSelection.order'), onClickButton: function () { return setOpenOrderFrom(true); }, isUSRoaster: isUSRoaster }))),
        React.createElement(CuppingCommentsDialog, { editable: false, orderedItem: cuppingCommentOrderedItem, onChange: setCuppingCommentOrderedItem })));
};
export default RoasterTypicaSelectionPage;
